import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { contact, schedule, whatsappUrl } from '../content/siteContent';

const { FiMapPin, FiPhone, FiFacebook, FiClock, FiMessageCircle, FiArrowUpRight } = FiIcons;

function ContactSection() {
  return (
    <section className="contact section" id="contacto">
      <div className="container contact__grid">
        <div className="contact__intro">
          <span className="eyebrow">Estamos para resolver</span>
          <h2>Habla con <em>nosotros.</em></h2>
          <p>Muchacho E’ Mandao — mandados, diligencias y entregas en Bonao.</p>
          <a className="button button--large" href={whatsappUrl()} target="_blank" rel="noreferrer">
            <SafeIcon icon={FiMessageCircle} /> Escribir por WhatsApp <SafeIcon icon={FiArrowUpRight} />
          </a>
        </div>
        <div className="contact__details">
          <a href={whatsappUrl()} target="_blank" rel="noreferrer">
            <span><SafeIcon icon={FiPhone} /></span>
            <div><small>Teléfono y WhatsApp</small><strong>{contact.phoneDisplay}</strong></div>
          </a>
          <div>
            <span><SafeIcon icon={FiMapPin} /></span>
            <div><small>Ubicación pública</small><strong>{contact.address}</strong></div>
          </div>
          <a href={contact.facebookUrl} target="_blank" rel="noreferrer">
            <span><SafeIcon icon={FiFacebook} /></span>
            <div><small>Facebook</small><strong>{contact.facebook}</strong></div>
          </a>
        </div>
        <aside className="schedule-card">
          <span className="schedule-card__icon"><SafeIcon icon={FiClock} /></span>
          <div><small>Horario</small><h3>Cuando necesites resolver</h3></div>
          <dl>
            <div><dt>Lunes a viernes</dt><dd>{schedule.weekdays}</dd></div>
            <div><dt>Sábado y domingo</dt><dd>{schedule.weekends}</dd></div>
          </dl>
        </aside>
      </div>
    </section>
  );
}

export default ContactSection;